import { PluralizeWordsType } from '@/types/pluralize';

/**
 * Определяет падежное окончание слова в зависимости от числа сущностей.
 * @param count Число сущностей
 * @param variants Варианты слова в разных падежах. Пример: { one: 'кот', two: 'кота', five: 'котов' }
 * @returns Слово с нужным падежным окончанием
 */
export const plural = (count: number, variants: PluralizeWordsType): string => {
  const lastTwo = count % 100;

  if (lastTwo > 10 && lastTwo < 20) {
    return variants.five;
  }

  const last = count % 10;

  if (last === 1) {
    return variants.one;
  }

  if (last > 1 && last < 5) {
    return variants.two;
  }

  return variants.five;
};

/**
 * Формирует строку с числом и словами до/после в нужном падеже.
 * @param count Число сущностей
 * @param variantsAfter Варианты после числа
 * @param variantsBefore Варианты перед числом
 * @returns Например, для count = 7: 'пришли 7 котов'
 */
export const pluralize = (
  count: number,
  variantsAfter: PluralizeWordsType | null = null,
  variantsBefore: PluralizeWordsType | null = null,
): string =>
  `${variantsBefore ? `${plural(count, variantsBefore)} ` : ''}${count}${
    variantsAfter ? ` ${plural(count, variantsAfter)}` : ''
  }`;
